__turbopack_context__.v({
  "accent": "Illustration-module__1ip0LG__accent",
  "bg": "Illustration-module__1ip0LG__bg",
  "root": "Illustration-module__1ip0LG__root",
});
